module.exports = __webpack_public_path__ + "img/spotify.29318090.svg";